/**
 * Shared Zod schemas - Single source of truth for types
 *
 * IMPORTANT: Define enums and common types HERE as Zod schemas,
 * then derive TypeScript types using z.infer<>. This prevents
 * type drift between Zod validation and TypeScript types.
 */
import { z } from 'zod';
/**
 * Game phases - all possible states a game room can be in
 */
export const GamePhaseSchema = z.enum([
    'lobby', // Waiting for players, selecting game
    'settings', // Configuring game settings before start
    'playing', // Game in progress
    'paused', // Game paused
    'results', // Showing round/game results
    'ended', // Game finished
]);
/**
 * Player connection status
 */
export const ConnectionStatusSchema = z.enum(['connected', 'disconnected', 'reconnecting']);
/**
 * Client types
 */
export const ClientTypeSchema = z.enum(['host', 'controller', 'spectator']);
/**
 * Player roles in a room
 */
export const PlayerRoleSchema = z.enum(['player', 'spectator', 'observer']);
/**
 * Public player info schema - for validation
 * Note: The TypeScript interface is in types.ts with branded PlayerId
 */
export const PublicPlayerInfoSchema = z.object({
    id: z.string(),
    name: z.string(),
    avatar: z.string().optional(),
    connectionStatus: ConnectionStatusSchema,
    score: z.number(),
});
//# sourceMappingURL=schemas.js.map